import { LicenseManager } from 'ag-grid-enterprise'
import { AG_GRID_KEY } from './config/ag-grid-license'

function setAgGridLicense() {
  LicenseManager.setLicenseKey(AG_GRID_KEY)
}

export async function initializeApp() {
  await new Promise<void>((resolve) => {
    setAgGridLicense()
    resolve()
  })
}
